import { render, staticRenderFns } from "./DescriptionList.vue?vue&type=template&id=5a2d83d3&scoped=true&"
import script from "./DescriptionList.vue?vue&type=script&lang=ts&"
export * from "./DescriptionList.vue?vue&type=script&lang=ts&"
import style0 from "./DescriptionList.vue?vue&type=style&index=0&id=5a2d83d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2d83d3",
  null
  
)

export default component.exports